"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var data_structures_1 = require("@tableau/data-structures");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var reselect_1 = require("reselect");
var Localize_1 = require("../../../gen-src/Localize");
var SmallInlineFadeInSpinner_1 = require("./SmallInlineFadeInSpinner");
var margin = {
    marginLeft: widgets_1.TabStyles.Spacing.DefaultSpace,
    marginRight: widgets_1.TabStyles.Spacing.DefaultSpace,
};
var buttonStyle = __assign(__assign({}, margin), { paddingLeft: widgets_1.TabStyles.Spacing.MediumSpace, paddingRight: widgets_1.TabStyles.Spacing.MediumSpace });
var containerClass = data_catalog_shared_1.cssClass('MultiSelectionControls_container', {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
});
// matches vizportalclient's divider styles
var dividerClass = data_catalog_shared_1.cssClass('MultiSelectionControls_divider', __assign(__assign({}, margin), { display: 'inline-block', height: 20, width: 1, backgroundColor: widgets_1.TabStyles.Colors.L3 })); // resolve conflicting types, but FIXME better than this someday
var textClass = data_catalog_shared_1.cssClass('MultiSelectionControls_text', __assign(__assign({}, margin), { fontSize: widgets_1.TabStyles.Typography.Sizing.Default })); // resolve conflicting types, but FIXME better than this someday
var MultiSelectionControls = /** @class */ (function (_super) {
    __extends(MultiSelectionControls, _super);
    function MultiSelectionControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiSelectionControls.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_apollo_1.ApolloConsumer, null, function (client) { return React.createElement(MultiSelectionControlsInternal, __assign({}, _this.props, { client: client })); }));
    };
    return MultiSelectionControls;
}(React.PureComponent));
exports.MultiSelectionControls = MultiSelectionControls;
var MultiSelectionControlsInternal = /** @class */ (function (_super) {
    __extends(MultiSelectionControlsInternal, _super);
    function MultiSelectionControlsInternal(props) {
        var _this = _super.call(this, props) || this;
        // tslint:disable-next-line: typedef
        _this.memoizedGetKeySetSize = reselect_1.defaultMemoize(data_structures_1.getKeySetSize);
        _this.mounted = false;
        _this.onSelectAll = function () { return __awaiter(_this, void 0, void 0, function () {
            var keys, selectedKeys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ selecting: true });
                        return [4 /*yield*/, this.props.fetchAllKeys(this.props.client)];
                    case 1:
                        keys = _a.sent();
                        if (this.mounted) {
                            this.setState({ selecting: false });
                            selectedKeys = data_structures_1.stringListToKeySet(keys);
                            this.props.setSelectedKeys(selectedKeys);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onClearAll = function () {
            _this.props.setSelectedKeys({});
        };
        _this.state = {
            selecting: false,
        };
        return _this;
    }
    MultiSelectionControlsInternal.prototype.componentDidMount = function () {
        this.mounted = true;
    };
    MultiSelectionControlsInternal.prototype.componentWillUnmount = function () {
        this.mounted = false;
    };
    MultiSelectionControlsInternal.prototype.render = function () {
        return (React.createElement("span", { className: containerClass },
            React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.LowEmphasis, disabled: this.state.selecting, handleClick: this.onSelectAll, style: buttonStyle, testId: 'select-all' }, Localize_1.Messages.SelectAll()),
            this.renderClearAndCountOrSelecting()));
    };
    MultiSelectionControlsInternal.prototype.renderClearAndCountOrSelecting = function () {
        if (this.state.selecting) {
            return React.createElement(SmallInlineFadeInSpinner_1.SmallInlineFadeInSpinner, null);
        }
        else {
            var selectedItemCount = this.memoizedGetKeySetSize(this.props.selectedKeys);
            if (selectedItemCount > 0) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.LowEmphasis, handleClick: this.onClearAll, style: buttonStyle, testId: 'clear-all' }, Localize_1.Messages.ClearAll()),
                    React.createElement("span", { className: dividerClass }),
                    React.createElement("span", { className: textClass }, Localize_1.Messages.XItemsSelected({
                        COUNT: selectedItemCount,
                        COUNT_LOC: Localize_1.Formatters.formatCount(selectedItemCount)
                    }))));
            }
            else {
                return null;
            }
        }
    };
    return MultiSelectionControlsInternal;
}(React.PureComponent));
//# sourceMappingURL=MultiSelectionControls.js.map